module.exports = __webpack_public_path__ + "media/images/bg-ethereum-573e6b9e10fce40b00903d92a4f432a9.jpg";